import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'

const DamIcon: React.FC = () => (
    <SvgIcon fontSize='small' viewBox='0 0 21 20'>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10.5 16.25C13.9518 16.25 16.75 13.4518 16.75 10C16.75 6.54822 13.9518 3.75 10.5 3.75C7.04822 3.75 4.25 6.54822 4.25 10C4.25 13.4518 7.04822 16.25 10.5 16.25ZM10.5 17.5C14.6421 17.5 18 14.1421 18 10C18 5.85786 14.6421 2.5 10.5 2.5C6.35786 2.5 3 5.85786 3 10C3 14.1421 6.35786 17.5 10.5 17.5Z'
            fill='#C7CAD4'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10.5 13.125C12.2259 13.125 13.625 11.7259 13.625 10C13.625 8.27411 12.2259 6.875 10.5 6.875C8.77411 6.875 7.375 8.27411 7.375 10C7.375 11.7259 8.77411 13.125 10.5 13.125ZM10.5 14.375C12.9162 14.375 14.875 12.4162 14.875 10C14.875 7.58375 12.9162 5.625 10.5 5.625C8.08375 5.625 6.125 7.58375 6.125 10C6.125 12.4162 8.08375 14.375 10.5 14.375Z'
            fill='#C7CAD4'
        />
        <path
            d='M11.75 10C11.75 10.6904 11.1904 11.25 10.5 11.25C9.80964 11.25 9.25 10.6904 9.25 10C9.25 9.30964 9.80964 8.75 10.5 8.75C11.1904 8.75 11.75 9.30964 11.75 10Z'
            fill='#C7CAD4'
        />
    </SvgIcon>
)
export default DamIcon
